// Mock data for Avalon X Media GmbH Website

export const companyInfo = {
  name: 'Avalon X Media GmbH',
  tagline: 'Data-Driven Lead Generation for Advertisers',
  description:
    'We deliver high-quality, GDPR-compliant leads through premium traffic funnels and performance channels.',
  address: 'Schozacherstr. 40, 70437 Stuttgart, Germany',
  email: 'service@avalonxmedia.com',
  phone: '+49 172 3541325',
  founded: '2019',
};

export const services = [
  {
    id: 'co-reg',
    title: 'Co-Registration Leads',
    shortDesc: 'High-converting multi-step registration flows that capture qualified user intent.',
    fullDesc:
      'Our co-registration funnels are designed to maximize conversion while ensuring data quality. Users opt-in to receive information from your brand during their registration journey, providing genuine interest signals.',
    icon: 'Users',
    metrics: { conversionRate: '12.5%', avgLeadQuality: '94%' },
  },
  {
    id: 'co-spo',
    title: 'Co-Sponsoring Leads',
    shortDesc: 'Premium placements in partner registration flows for maximum visibility.',
    fullDesc:
      'Leverage our network of premium publisher partners to reach highly engaged audiences. Sponsored placements ensure your brand appears prominently during user registration.',
    icon: 'Award',
    metrics: { reachPerMonth: '2.5M+', brandRecall: '78%' },
  },
  {
    id: 'email',
    title: 'Email Marketing',
    shortDesc: ' powered campaigns with industry-leading deliverability rates.',
    fullDesc: 'powered campaigns with industry-leading deliverability rates',
    icon: 'Mail',
    metrics: { deliverability: '99.8%', openRate: '32%' },
  },
  {
    id: 'sms',
    title: 'SMS DOI Funnels',
    shortDesc: 'Double opt-in SMS campaigns with real-time delivery and tracking.',
    fullDesc:
      'Reach customers directly on their mobile devices with compliant SMS marketing. Our DOI process ensures genuine consent and high engagement rates.',
    icon: 'Smartphone',
    metrics: { responseRate: '45%', optInRate: '89%' },
  },
  {
    id: 'sweepstakes',
    title: 'Lead Acquisition',
    shortDesc: 'Engaging campaigns that drive massive qualified lead volume.',
    fullDesc:
      'Our lead acquisition campaigns combine attractive offers with strategic targeting to generate high volumes of qualified leads while maintaining data quality.',
    icon: 'Gift',
    metrics: { avgCPL: '€0.35', participationRate: '67%' },
  },
  {
    id: 'phone',
    title: 'Phone Lead Delivery',
    shortDesc: 'Real-time validated phone leads with guaranteed contact rates.',
    fullDesc:
      'We deliver phone-verified leads with real-time validation to ensure accuracy. Direct integration with your CRM for seamless lead flow.',
    icon: 'Phone',
    metrics: { validationRate: '97%', contactRate: '82%' },
  },
  {
    id: 'data',
    title: 'Data Monetization & Segmentation',
    shortDesc: 'Advanced audience segmentation for precision targeting.',
    fullDesc:
      'Transform raw data into actionable segments. Our advanced analytics identify high-value audience clusters for maximum campaign effectiveness.',
    icon: 'Database',
    metrics: { segments: '50+', accuracyRate: '96%' },
  },
  {
    id: 'api',
    title: 'API Delivery & Real-time Validation',
    shortDesc: 'Seamless integration with instant lead delivery and verification.',
    fullDesc:
      'Our robust API infrastructure enables real-time lead delivery with instant validation. Reduce fraud and improve data quality automatically.',
    icon: 'Zap',
    metrics: { responseTime: '<100ms', uptime: '99.99%' },
  },
];

export const usps = [
  {
    title: 'Direct Source',
    description: '100% first-party leads from our proprietary traffic network.',
    icon: 'Target',
  },
  {
    title: 'GDPR Compliant',
    description: 'Full regulatory compliance with transparent consent management.',
    icon: 'Shield',
  },
  {
    title: 'High Deliverability',
    description: 'Industry-leading email delivery rates powered by .',
    icon: 'Send',
  },
  {
    title: 'Real-time Validation',
    description: 'Instant verification ensures data accuracy and reduces fraud.',
    icon: 'CheckCircle',
  },
  {
    title: 'Custom Funnels',
    description: 'Tailored acquisition flows for your specific vertical and goals.',
    icon: 'Settings',
  },
  {
    title: 'Transparent Reporting',
    description: 'Real-time dashboards with full campaign visibility.',
    icon: 'BarChart3',
  },
];

export const caseStudies = [
  {
    id: 1,
    client: 'Leading Insurance Provider',
    vertical: 'Insurance',
    challenge: 'Needed to scale lead acquisition while maintaining strict quality standards.',
    solution: 'Implemented multi-channel funnel combining co-registration and email marketing.',
    results: {
      leadsGenerated: '125,000+',
      costReduction: '40%',
      conversionLift: '2.3x',
    },
  },
  {
    id: 2,
    client: 'Major E-commerce Retailer',
    vertical: 'E-commerce',
    challenge: 'Expand customer base during peak seasonal periods.',
    solution: 'Deployed sweepstakes campaigns with targeted email follow-up sequences.',
    results: {
      newCustomers: '85,000+',
      roas: '380%',
      emailEngagement: '45%',
    },
  },
  {
    id: 3,
    client: 'FinTech Startup',
    vertical: 'Finance',
    challenge: 'Acquire high-quality leads for a new financial product launch.',
    solution: 'Built custom co-registration funnel with SMS verification.',
    results: {
      qualifiedLeads: '42,000+',
      cpl: '€1.20',
      signupRate: '28%',
    },
  },
];

export const partners = [
  { name: 'TechCorp', logo: null },
  { name: 'DataFirst', logo: null },
  { name: 'LeadGen Pro', logo: null },
  { name: 'AdNetwork', logo: null },
  { name: 'TrafficMax', logo: null },
  { name: 'ConvertPlus', logo: null },
];

export const team = [
  {
    name: 'Michael Weber',
    role: 'CEO & Founder',
    bio: '15+ years in digital marketing and lead generation.',
    image: null,
  },
  {
    name: 'Anna Schmidt',
    role: 'Head of Operations',
    bio: 'Expert in process optimization and campaign management.',
    image: null,
  },
  {
    name: 'Thomas Müller',
    role: 'CTO',
    bio: 'Technology leader with expertise in data systems and APIs.',
    image: null,
  },
  {
    name: 'Lisa Hoffmann',
    role: 'Head of Compliance',
    bio: 'GDPR specialist ensuring data protection excellence.',
    image: null,
  },
];

export const verticals = [
  'Finance',
  'Insurance',
  'E-commerce',
  'Retail',
  'Mobility',
  'Sweepstakes',
  'FMCG',
];

export const stats = [
  { value: '50M+', label: 'Leads Delivered ->  24/7' },
  { value: '500+', label: 'Campaigns Delivered' },
  { value: '99.8%', label: 'Email Deliverability' },
  { value: '100%', label: 'GDPR Compliant' },
];

export const advertiserBenefits = [
  {
    title: '100% GDPR-Compliant Leads',
    description:
      'Every lead is collected with explicit, documented consent meeting and EU data protection standards.',
    icon: 'Shield',
  },
  {
    title: 'Custom Traffic Filters',
    description:
      "Define your ideal customer profile and we'll filter traffic to match your exact specifications.",
    icon: 'Filter',
  },
  {
    title: 'CPL-Based Billing',
    description:
      'Pay only for qualified leads that meet your criteria. No hidden fees, complete transparency.',
    icon: 'CreditCard',
  },
  {
    title: 'Quality Control & Deduplication',
    description:
      'Advanced algorithms ensure lead freshness and eliminate duplicates across campaigns.',
    icon: 'CheckSquare',
  },
  {
    title: 'Real-time Dashboard Reporting',
    description: 'Monitor your campaigns 24/7 with detailed analytics and performance metrics.',
    icon: 'LayoutDashboard',
  },
  {
    title: 'Dedicated Account Management',
    description: 'Work directly with experienced professionals who understand your business goals.',
    icon: 'UserCheck',
  },
];
